<template>
  <div class="active_page">
    <img class="img_bg" :src="ainfo.background_pic" />
    <!-- <div class="location_box">
      <img class="active_local_img" :src="img.active_local">
      <div>全国</div>
      <div class="top_active_name">全国卡丁车圈速赛</div>
    </div> -->
    <div class="active_form_box">
      <div class="audit_title">{{ainfo.title}}</div>
      <div class="form_box">
        <div class="input_cell">
          <div class="input_name">
            <div class="request_star">*</div>
            姓名/昵称
          </div>
          <div class="input_form">
            <van-field v-model="params.name" placeholder="填写姓名/昵称" />
          </div>
        </div>
        <div class="input_cell">
          <div class="input_name">
            <div class="request_star">*</div>
            手机号
          </div>
          <div class="input_form">
            <van-field v-model="params.mobile" placeholder="填写手机号" maxlength='11' type='tel' />
          </div>
        </div>
        <div class="input_cell">
          <div class="input_name">
            <div class="request_star">*</div>
            邮寄地址
          </div>
          <div class="input_form">
            <van-field v-model="params.city" placeholder="填写邮寄详细地址" />
          </div>
        </div>
        <div class="input_cell">
          <div class="input_img_name">
            <div class="request_star">*</div>
            认证图片
          </div>
          <div class="input_img_form">
            <van-uploader :after-read="uploadActiveImg" accept="image/*">
              <img v-if="imgcover_url" class="one_img_pic" :src="imgcover_url" /> 
            </van-uploader>
            <div class="input_img_form_text">上传认证图片</div>
          </div>
        </div>
      </div>
    </div>
    <div class="active_fixed_btn">
      <div class="fix_btn" @click="nextStep()">{{ainfo.ticket_text?ainfo.ticket_text:'提交报名信息'}}</div>
    </div>
  </div>
</template>

<script>
  import common from '../../../api/common';
  import post from '../../../api/toyota/api';
  import { mapState } from 'vuex';
  import {Field,Uploader,Toast } from 'vant';
  export default {
    data () {
      return {
        hid:24,
        ainfo:'',
        info:'',
        params:{
          name:'',
          mobile:'',
          city:'',
          picture:'',
          is_family:'0',
        },
        imgcover_url:'',
        img:{
          active_local: require('../../../assets/img/toyota/active/active_local.png')
        }
      }
    },
    created () {
      this.getActiveInfo()
    },
    methods: {
      getActiveInfo(){
        post.getActiveInfo({id:this.hid}).then(res => {
          if(res.data.state==1){
            this.ainfo=res.data.data
            document.title = res.data.data.title;
          } else {
            Toast(res.data.error[0]);
            return false
          }
        })
      },
      uploadActiveImg(file) {
        let params = new FormData()
        params.append('img', file.file)
        common.uploadImg(params).then(res => {
          if(res.data.state == 1) {
            console.log(res)
            this.imgcover_url=res.data.data.img_url
            this.params.picture=res.data.data.img
          }
        })
      },
      nextStep(){
        var that=this
        that.params.hid=this.hid
        post.activePost(that.params).then(res => {
          if(res.data.state==1){
            Toast.success('提交成功');
            setTimeout(function() {
              window.location.href ='https://m.motortime.com/toyota/active/activeaudit?token='+res.data.data.token+'&scene='+new Date().getTime()
              that.params={
                name:'',
                mobile:'',
                city:'',
                picture:'',
                is_family:'0',
              }
              that.imgcover_url=''
          },1300)
          } else {
            Toast(res.data.error[0]);
            return false
          }
        })
        // if (!that.params.mobile) {
        //   Toast('请输入手机号');
        // } else {
        //   if (!(/^1[3456789]\d{9}$/.test(that.params.mobile))) {
        //     Toast('请填写正确的手机号');
        //   } else {

        //   }
        // }
        
      },

    },
    components: {
      [Field.name]: Field,
      [Uploader.name]: Uploader,
      [Toast.name]:Toast 
    }
  };
</script>

<style lang="scss">
  .active_page {
    height: 100vh;
    overflow-y: hidden;
    position:relative;
    .active_form_box{
      width: 100%;
      position: absolute;
      top: 0;
      bottom:0;
      z-index: 2;
    }
    .img_bg{
      width: 100%;
      position: absolute;
      top: 0;
      bottom:0;
      z-index: 1;
    }
    .audit_title{
      color: #AA0000;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      margin-top: 10%;
      margin-bottom: 25px;
    }
    // .location_box {
    //   position:sticky;
    //   top: 0;
    //   left: 0;
    //   right: 0;
    //   z-index: 2;
    //   font-size: 12px;
    //   padding: 20px 20px;
    //   display: flex;
    //   align-items: center;
    //   background-color:rgba(255,255,255,0.5);
    //   // border-bottom: 1px solid #F1F1F1;
    //   // border-top: 1px solid #F1F1F1;

    //   .active_local_img {
    //     width: 25px;
    //     height: 24px;
    //     margin-right: 15px;
    //   }

    //   .top_active_name {
    //     color: #333333;
    //     font-size: 16px;
    //     margin-left: 15px;
    //   }
    // }
    .form_box {
      border: 2px solid #AA0000;
      background-color: #fff8f8;
      border-radius: 2px;
      padding: 0 20px;
      margin: 20px;
      .input_cell {
        display: flex;
        align-items: center;
        margin: 40px 0;

      }

      .input_name {
        color: #fff;
        font-size: 12px;
        background-color: #AA0000;
        width: 75px;
        height: 32px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border: 2px solid #AA0000;

      }
      .input_img_name{
        color: #fff;
        font-size: 12px;
        background-color: #AA0000;
        width: 75px;
        height: 118px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border: 2px solid #AA0000;
      }
      .request_star {
        color: red;
        font-size: 12px;
        width: 12px;
      }

      .input_form {
        flex: 1;
        height: 32px;
        border: 2px solid #AA0000;
        .van-cell{
          height: 32px;
          padding: 0 15px;
          font-size: 12px;
          display: flex;
          align-items:center;
        }

      }
      .input_img_form{
        display: flex;
        align-items: center;
        flex: 1;
        height: 118px;
        border: 2px solid #AA0000;
        .van-uploader__upload{
          background-color: #eaeaea;
          border-radius: 0;
          margin: 0;
          margin-left: 15px;
        }
        .input_img_form_text{
          font-size: 10px;
          color: #9a9a9a;
          margin-left: 10px;
        }
        .van-uploader__upload{
          width: 90px;
          height: 90px;
        }
      }
      .one_camera {
        width: 25px;
        height: 22px;
        margin-top: 35%;
      }

      .one_form {
        display: flex;
        align-items: center;
        margin-left: 20px;
      }

      .one_img {
        width: 90px;
        height: 90px;
        color: #666666;
        background-color: #EEEEEE;
        margin-right: 10px;
      }

      .one_img_pic {
        width: 90px;
        height: 90px;
        margin-left: 15px;
        object-fit: cover;
      }

    }
    .active_fixed_btn{
      width: 100%;
      position: fixed;
      bottom: 50px;
      margin-top:25px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      .fix_btn{
        text-align: center;
        background-color: #AA0000;
        color: #fff;
        border-radius: 25px;
        font-size: 14px;
        padding: 12px 0;
        width: 150px;
      }
    }
  }
</style>
